<template>
    <div>
        <div class="app-header" :class="{ 'app-header-bg': $device !== 'mobile' }">
            <img src="/Images/aside_image/logo.png" style="z-index:30;margin-left: 20px;">
            <span class="icon">{{ header_msg }}</span>
            <div v-if="back_status" class="back" @click="back()">
                <i class="el-icon-s-home"></i>
                <span>返回</span>
            </div>
            <!--            <el-button type="primary" icon="el-icon-arrow-left" title="返回首页" size="mini"-->
            <!--                       style="margin-left: 20px;" @click="back()">返回-->
            <!--            </el-button>-->
        </div>
        <div class="app-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            header_msg: '',
            back_status: false
        }
    },
    methods: {
        back() {
            // const link = this.$route.query.link;
            // this.$router.replace({path: '/', query: {link: link}});
            this.$router.replace('/');
            // window.history.go(-1);
        }
    },
    watch: {
        $route(to, from) {
            if (to.path.indexOf('demo') === -1) {
                this.back_status = false;
            } else {
                this.back_status = true;
            }
        }
    },
    mounted() {
        this.header_msg = qexc.header_msg;
    },
}
</script>

<style lang="less">
@smx-header-height: 65px;

.app-header {
    height: @smx-header-height;
    line-height: @smx-header-height;
    padding: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 999;
    background-color: #07081c;

    &-bg {
        background-image: url('/Images/aside_image/background.png');
        background-size: 95% 100%;
        background-repeat: no-repeat;
    }

    .icon {
        font-size: 15px;
        color: white;
        z-index: 200;
        margin-left: 16px;
        /*position: absolute;*/
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .back {
        position: absolute;
        right: 20px;
        line-height: 65px;
        z-index: 99999;
        /* display: inline-block; */
        top: 0;
        color: #fff;
        font-size: 14px;
        cursor: pointer;

        &:hover {
            color: #1690ff;
        }
    }
}

.app-body {
    // <!--margin-top: @smx-header-height;-->
    position: relative;
    top: @smx-header-height;
    height: calc(100vh - @smx-header-height);
}
</style>
